import { getField } from 'vuex-map-fields';

// TYPES

export const SET_FILTERS_DATA_KEY = 'SET_FILTERS_DATA_KEY';
export const SET_FILTER_STATE = "SET_FILTER_STATE";
export const SET_FILTER_CONCEPT = "SET_FILTER_CONCEPT";
export const SET_FILTER_DATE_FROM = "SET_FILTER_DATE_FROM";
export const SET_FILTER_DATE_TO = "SET_FILTER_DATE_TO";
export const SET_FILTER_EFFECT_TYPE = "SET_FILTER_EFFECT_TYPE";
export const SET_FILTER_ORIGIN = "SET_FILTER_ORIGIN";
export const SET_FILTER_ACCOUNT = "SET_FILTER_ACCOUNT";
export const SET_FILTER_TOTAL_AMOUNT = "SET_FILTER_TOTAL_AMOUNT";
export const SET_FILTER_TOTAL_AMOUNT_FROM = "SET_FILTER_TOTAL_AMOUNT_FROM";
export const SET_FILTER_TOTAL_AMOUNT_TO = "SET_FILTER_TOTAL_AMOUNT_TO";
export const CLEAN_FILTER = "CLEAN_FILTER";
export const RESET_FILTERS = "RESET_FILTERS";


// STATE
const state = () => ({
    listFilters: {        
        state: {
            'name': 'state',
            'label': 'Estado',
            'values':[], // TODO: multiple?
            'user_values': [
                { value: '', text: 'Todos'},
                { value: 'no_punteado', text: 'No punteado'},
                { value: 'punteado_parcial', text: 'Punteado Parcialmente'},
                { value: 'punteado', text: 'Punteado'},
                { value: 'punteado_manualmente', text: 'Punteado Manualmente'},
            ],
            'multiple': false,
            'value': '',
            'type': 'select',
            'icon': 'mdi-file-chart',
            'text':''
        },
        concept: {
            'name': 'concept',
            'label': 'Concepto',
            'value': '',
            'type': 'text',
            'icon': 'mdi-file-document',
        },       
        date_from: {
            'name': 'date_from',
            'label': 'Fecha desde',
            'value': '',
            'type': 'date',
            'icon': 'mdi-calendar',
        },
        date_to: {
            'name': 'date_to',
            'label': 'Fecha hasta',
            'value': '',
            'type': 'date',
            'icon': 'mdi-calendar',
        },
        effect_type: {
            'name': 'effect_type',
            'label': 'Tipo efecto',
            'values':[], // TODO: multiple?
            'user_values': [
                { value: '', text: 'Todos'},
                { value: 'payable_effect', text: 'Efecto de pago'},
                { value: 'receivable_effect', text: 'Efecto de cobro'},
            ],
            'multiple': false,
            'value': '',
            'type': 'select',
            'icon': 'mdi-file-chart',
            'text':''
        },
        origin: {
            'name': 'origin',
            'label': 'Origen',
            'values':[], // TODO: multiple?
            'user_values': [
                { value: '', text: 'Todos'},
                { value: 'excel_effect', text: 'Excel'},
                { value: 'inmatic', text: 'Inmatic'},
                { value: 'accounting_program_effect', text: 'Programa Contable'},
                { value: 'manual', text: 'Manual'},
            ],
            'multiple': false,
            'value': '',
            'type': 'select',
            'icon': 'mdi-earth',
            'text':''
        },
        account: {
            'name': 'account',
            'label': 'Cuenta',
            'value': '',
            'type': 'text',
            'icon': 'mdi-file-document',
        },
        total_amount: {
            'name': 'total_amount',
            'label': 'Importe exacto',
            'value': '',
            'type': 'number',
            'icon': 'mdi-currency-eur',
        },
        total_amount_from: {
            'name': 'total_amount_from',
            'label': 'Importe desde',
            'value': '',
            'type': 'number',
            'icon': 'mdi-currency-eur',
        },
        total_amount_to: {
            'name': 'total_amount_to',
            'label': 'Importe hasta',
            'value': '',
            'type': 'number',
            'icon': 'mdi-currency-eur',
        }
    }
});

// GETTERS
const getters = {
    listFilters: state => state.listFilters,
    getField
}

// ACTIONS

const removeAllFilters = ({commit},p) => {
    let value=''
    let text=''
    commit(SET_FILTER_CONCEPT, value);   
    commit(SET_FILTER_STATE, {value,text});
    commit(SET_FILTER_DATE_FROM, value);
    commit(SET_FILTER_DATE_TO, value);
    commit(SET_FILTER_EFFECT_TYPE, {value,text});
    commit(SET_FILTER_ORIGIN, {value,text});
    commit(SET_FILTER_ACCOUNT, {value,text});
    commit(SET_FILTER_TOTAL_AMOUNT, value);
    commit(SET_FILTER_TOTAL_AMOUNT_FROM, value);
    commit(SET_FILTER_TOTAL_AMOUNT_TO, value);}

const updateObject = ({commit}, {key,value,text}) => {
    if(key=='concept')
        commit(SET_FILTER_CONCEPT, value);
    if(key=='state')
        commit(SET_FILTER_STATE, {value,text});
    if(key=='date_from')
        commit(SET_FILTER_DATE_FROM, value);
    if(key=='date_to')
        commit(SET_FILTER_DATE_TO, value);
    if(key=='effect_type')
        commit(SET_FILTER_EFFECT_TYPE, {value,text});
    if(key=='origin')
        commit(SET_FILTER_ORIGIN, {value,text});
    if(key=='account')
        commit(SET_FILTER_ACCOUNT, {value,text});
    if(key=='total_amount')
        commit(SET_FILTER_TOTAL_AMOUNT, value);
    if(key=='total_amount_from')
        commit(SET_FILTER_TOTAL_AMOUNT_FROM, value);
    if(key=='total_amount_to')
        commit(SET_FILTER_TOTAL_AMOUNT_TO, value);
};

const setFilterState = ({commit}, value) => {
    commit(SET_FILTER_STATE, value);
};

const setFilterConcept = ({commit}, value) => {
    commit(SET_FILTER_CONCEPT, value);
};

const setFilterDateFrom = ({commit}, value) => {
    commit(SET_FILTER_DATE_FROM, value);
};
const setFilterDateTo = ({commit}, value) => {
    commit(SET_FILTER_DATE_TO, value);
};

const setFilterEffectType = ({commit}, value) => {
  commit(SET_FILTER_EFFECT_TYPE, value);
};
const setFilterOrigin = ({commit}, value) => {
    commit(SET_FILTER_ORIGIN, value);
};

const setFilterAccount = ({commit}, value) => {
    commit(SET_FILTER_ACCOUNT, value);
};

const setFilterTotalAmount = ({commit}, value) => {
    commit(SET_FILTER_TOTAL_AMOUNT, value);
};

const setFilterTotalAmountFrom = ({commit}, value) => {
    commit(SET_FILTER_TOTAL_AMOUNT_FROM, value);
};

const setFilterTotalAmountTo = ({commit}, value) => {
    commit(SET_FILTER_TOTAL_AMOUNT_TO, value);
};

const setFilter = ({commit}, {key, value}) => {
    commit(SET_FILTERS_DATA_KEY, {key, value});
};

const cleanFilter = ({commit}, key) => {
    commit(CLEAN_FILTER, key);
};

const resetFilters = ({commit}) => {
    commit(RESET_FILTERS);
};

export const actions = {   
    setFilterState,
    setFilterConcept,    
    setFilterDateFrom,
    setFilterDateTo,
    setFilterEffectType,
    setFilterOrigin,
    setFilterAccount,
    setFilterTotalAmount,
    setFilterTotalAmountFrom,
    setFilterTotalAmountTo,
    setFilter,
    cleanFilter,
    resetFilters,
    updateObject,
    removeAllFilters,
}

// MUTATIONS
const mutations = {
    [SET_FILTERS_DATA_KEY](state, {key, value}) {
        state.listFilters[key].value = value;
    },    
    [SET_FILTER_STATE](state, {value,text}) {
        state.listFilters['state'].value = value;
        state.listFilters['state'].text = text;
    },
    [SET_FILTER_CONCEPT](state, value) {
        state.listFilters['concept'].value = value;
    },   
    [SET_FILTER_DATE_FROM](state, value) {
        state.listFilters['date_from'].value = value;
    },
    [SET_FILTER_DATE_TO](state, value) {
        state.listFilters['date_to'].value = value;
    },
    [SET_FILTER_EFFECT_TYPE](state, {value,text}) {
        state.listFilters['effect_type'].value = value;
        state.listFilters['effect_type'].text = text;
    },
    [SET_FILTER_ORIGIN](state, {value,text}) {
        state.listFilters['origin'].value = value;
        state.listFilters['origin'].text = text;
    },
    [SET_FILTER_ACCOUNT](state, {value,text}) {
        state.listFilters['account'].value = value;
        state.listFilters['account'].text = text;
    },
    [SET_FILTER_TOTAL_AMOUNT](state, value) {
        state.listFilters['total_amount'].value = value;
    },
    [SET_FILTER_TOTAL_AMOUNT_FROM](state, value) {
        state.listFilters['total_amount_from'].value = value;
    },
    [SET_FILTER_TOTAL_AMOUNT_TO](state, value) {
        state.listFilters['total_amount_to'].value = value;
    },
    [CLEAN_FILTER](state, key) {
        state.listFilters[key].value = '';
    },
    [RESET_FILTERS](state) {
        for (const key in state.listFilters) {
            state.listFilters[key].value = '';
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}